export enum ScanLabelArchetype {
  NONE = "",
  DEAD = "Dead",
  NON_READER = "Non-Reader",
  NO_TAG = "No Tag",
}
